import { TokenResponse } from '@okta/okta-auth-js';
import getConfig from 'next/config';

import createOktaAuthClient from '../services/okta/createOktaAuthClient';
import fetch from '../utils/public/fetch';

const loginWithFacebook = async () => {
  const {
    publicRuntimeConfig,
  } = getConfig();

  const {
    redirectUri,
  } = publicRuntimeConfig.oidc;

  const oktaAuthClient = createOktaAuthClient();

  // prompt: 'login' forces the login to happen on facebook.  I was seeing issues where would log you
  // in to your existing okta session.
  // Don't try to await this, it causes issues with facebook login as ios safari no longer thinks
  // this is the direct result of a click, blocking the popup.
  return oktaAuthClient.token
    .getWithPopup({
      display: 'popup',
      idp: publicRuntimeConfig.oidc.facebookIdp,
      prompt: 'login',
      redirectUri: `${window.location.origin}${redirectUri}`,
      responseType: 'id_token',
    });
};

const storeTokenApi = async (idToken: string, refreshToken: string, accessToken:string) : Promise<Response> => await fetch(
  '/api/validate-tokens',
  {
    body: JSON.stringify({
      idToken,
      refreshToken,
      accessToken
    }),
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  }
);

const finishLoginApi = async (idToken: string) : Promise<Response> => await fetch(
  '/api/finish-login',
  {
    body: JSON.stringify({
      idToken,
    }),
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  }
);

const storeTokens = async (tokenResponse: TokenResponse, skipRefresh:Boolean = false) => {
  const {
    tokens,
  } = tokenResponse;
  const {
    idToken,
    refreshToken,
    accessToken
  } = tokens;

  const idTokenString = idToken?.idToken.valueOf();
  const accessTokenString = accessToken?.accessToken.valueOf() || '';
  let refreshTokenString = '';

  if (!skipRefresh) {
    refreshTokenString = refreshToken?.refreshToken.valueOf() || '';
  }

  if (idTokenString && (refreshTokenString || skipRefresh)) {
    const storeCallStatus = await storeTokenApi(idTokenString, refreshTokenString, accessTokenString);

    if (storeCallStatus.ok) {
      return storeCallStatus;
    }

    throw new Error(`Failed storing of tokens ${storeCallStatus.status}`);
  }
  const scrubbedTokenData = `
      missing tokens:
      idToken: ${idTokenString?.length || 0}
      refreshToken: ${refreshTokenString?.length || 0}
    `;

  throw new Error(scrubbedTokenData);
};

export {
  finishLoginApi,
  loginWithFacebook,
  storeTokens,
  storeTokenApi,
};
